<template>
  <UpgradeAccountModal :upgrade-type="UPGRADE_TO_EXTRA_MODAL">
    <template v-slot:reason-heading>
      This feature is for Extra and Pro members&nbsp;only
    </template>
    <template v-slot:main-message>
      Unlock all of our most powerful tools and features when you upgrade your membership
    </template>
    <template v-slot:sub-message>
      <p class="upgrade-account-message">
        Enjoy completely unrestricted access to all of our most powerful tools and features with an Extra- or Pro-level membership.
        Take your trading and investing to the next level and supercharge your StockCharts&nbsp;experience!
      </p>
    </template>
    <template v-slot:button-group>
      <a
        class="sc3-button sc3-button-light-green sc3-button-extra-large"
        href="/youracct/servicelevel"
        target="_blank"
      >
        <i class="fas fa-plus-circle"></i>
        &nbsp;&nbsp;Upgrade&nbsp;Now
      </a>
      <a
        class="sc3-button-link"
        href="/"
      >Learn More</a>
      <br />
      <button
        type="button"
        class="sc3-button-link close-button"
        @click="closeModal()"
      >
        No Thanks
      </button>
    </template>
  </UpgradeAccountModal>
</template>

<script lang="ts" setup>
  import { useModals } from '@/composables/useModals';
  import UpgradeAccountModal from '@/components/modals/UpgradeAccountModal.vue';

  const { UPGRADE_TO_EXTRA_MODAL, closeModal } = useModals();
</script>
